export const bm_hooks = {
    actions: {},
    filters: {},

    // ACTIONS
    addAction: function(name, callback) {
        if (!this.actions[name]) this.actions[name] = [];
        this.actions[name].push(callback);
    },
    doAction: function(name, ...args) {
        if (this.actions[name]) {

            this.actions[name].forEach((cb) => {
                try {
                    cb(...args);
                } catch (err) {
                    console.error(`[bm_hooks] action "${name}" failed`, err);
                }
            });
        }
    },

    // FILTERS
    addFilter: function(name, callback) {
        if (!this.filters[name]) this.filters[name] = [];
        this.filters[name].push(callback);
    },
    applyFilters: function(name, value, ...args) {
        if (this.filters[name]) {
            return this.filters[name].reduce((acc, cb) => {
                try {
                    return cb(acc, ...args);
                } catch (err) {
                    console.error(`[bm_hooks] filter "${name}" failed`, err);
                    return acc;
                }
            }, value);
        }
        return value;
    }
};
window.bm_hooks = bm_hooks;
